import React from 'react';

import StarIcon from 'buyside/svgs/star.svg';
import SZLogoIcon from 'buyside/svgs/logo.svg';

import styles from './highlightedRankingStyles.scss';

const HighlightedRanking: React.FC = () => {
  return (
    <div className={styles.highlightedRanking}>
      <StarIcon className={styles.starIcon} />
      <span>Top Ranked Analyst Recommendation</span>
      <SZLogoIcon className={styles.fadedLogo} />
    </div>
  );
};

export default HighlightedRanking;
